module.exports = __webpack_public_path__ + "img/winning001.a6b04cb.webp";